import React from 'react';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';
import MessageDisplayBoxWithTruncation from 'Components/ComponentLibrary/Molecules/MessageDisplayBoxWithTruncation';
import fr from 'facet-rest';
import {
  FDBodyText, FDBox, FDClickableText, FDStack,
} from '@facet-wealth/design';

const SystemStartOfRoutedThreadContent = ({ relatedMessage, messageResource, onRoutedThreadClick }) => {
  return (
    <FDStack spacing={3} direction={'column'} paddingY={1} {...dataAttrs('message-with-routed-thread-content')}>
      <FDBox>
        { messageResource.withRelationship(fr.relationships.specificThreadLink.name,
          (rel) => {
            return <span>{rel.meta('prePrompt')}&nbsp;<FDClickableText appearance={'standalone'} label={rel.meta('prompt')} onClick={() => onRoutedThreadClick(rel)} {...dataAttrs('routed-thread-clickable-text')} />&nbsp;{rel.meta('postPrompt')}</span>;
          },
          () => <FDBodyText value={'This thread was started from a message in another conversation.'} />)
        }
      </FDBox>
      {relatedMessage ? (
        <MessageDisplayBoxWithTruncation messageContent={relatedMessage.attr('content')} />
      ) : null}
    </FDStack>
  );
};

SystemStartOfRoutedThreadContent.propTypes = {
  relatedMessage: PropTypes.instanceOf(fr.Resource).isRequired,
  messageResource: PropTypes.instanceOf(fr.Resource).isRequired,
  onRoutedThreadClick: PropTypes.func.isRequired,
};

SystemStartOfRoutedThreadContent.defaultProps = {};

export default SystemStartOfRoutedThreadContent;
